import { SectionItem } from "../apis/privacy-policies";


export type GroupedSection = {
  sectionTitle: string;
  items: {
    subTitle?: string;
    content: string;
    sort: number;
  }[];
};

export function groupSections(data: SectionItem[]): GroupedSection[] {
  const published = data.filter((item) => item.status === 'published');

  const sorted = [...published].sort((a, b) => a.sort - b.sort);

  const grouped = new Map<string, SectionItem[]>();
  for (const item of sorted) {
    if (!grouped.has(item.sectionTitle)) {
      grouped.set(item.sectionTitle, []);
    }
    grouped.get(item.sectionTitle)!.push(item);
  }

  return Array.from(grouped.entries()).map(([sectionTitle, items]) => ({
    sectionTitle,
    items: items.map((i) => ({
      subTitle: i.sectionSubTitle || undefined,
      content: i.sectionContent,
      sort: i.sort,
    })),
  }));
}
